module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo_finals-e4c82a5954999bb644c8784c63cc1c68.png";